module.exports = __webpack_public_path__ + "assets/c72e4dd38c90dc97628f3cf1628575e7.mp3";